export const calculatePageCount = (dataLength: number): number => {
    if (dataLength < 4) {
      return 1
    } else {
      return Math.ceil(dataLength / 4)
    }
  }